import type { LanguageMap } from "@/services/category.service";
import { localizedText } from "./localization";
import type { TreeLike } from "./tree-model";

/**
 * Category English names are unique per catalogue, case-insensitively.
 * Every configured language is still required by the API.
 */
export function findNameClash<T extends TreeLike<T> & { name: LanguageMap }>(
  roots: T[],
  name: string,
  selfId?: string | null,
  language = "en",
): T | null {
  const target = name.trim().toLowerCase();
  if (!target) return null;

  for (const node of roots) {
    if (
      node.id !== selfId
      && localizedText(node.name, language).trim().toLowerCase() === target
    ) {
      return node;
    }
    const nested = findNameClash(node.children, name, selfId, language);
    if (nested) return nested;
  }
  return null;
}
